// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// Refactor. There's a lot unnecessary base methods here.

import { CustomEvent } from "../../../Utils/CustomEvents.js"
import { ErrorInformationStorage } from "../../../Commons/ErrorInformationStorage.js"
import { FINISH_BLOCK_TRANSFER } from "../../../Utils/CommonConst.js"
import { DirectAssetMessage } from "../../../Utils/DirectMessages/DirectMessagesImport.ts"
import { DirectPropertyMessage } from "../../../Utils/DirectMessages/DirectMessagesImport.ts"
import { DirectSessionMessage } from "../../../Utils/DirectMessages/DirectMessagesImport.ts"
import { DirectRemoveOrderMessage } from "../../../Utils/DirectMessages/DirectMessagesImport.ts"
import { DirectRouteMessage } from "../../../Utils/DirectMessages/DirectMessagesImport.ts"
import { generateReportMessageHandler } from "../../../Utils/AppHandlers.js"


export let DirectVendorBase = function ()
{
    this.login = null
    this.userSessionId = null
    // TODO.
    this.vendorName = ''

    this.OnNewMessage = new CustomEvent()
    this.OnConnected = new CustomEvent()
    this.OnDisconnected = new CustomEvent()

    //working here
    this.OnConnectionLost = new CustomEvent()
    this.OnError = new CustomEvent()

    this.FAssets = null
}

// #region Constants

DirectVendorBase.DELAY_BETWEEN_CROSSPRICES = 2000

// #endregion

DirectVendorBase.prototype.AddConnectedListener = function (method, context)
{
    this.OnConnected.Subscribe(method, context);
};

DirectVendorBase.prototype.RemoveConnectedListener = function (method, context)
{
    this.OnConnected.UnSubscribe(method, context);
};

DirectVendorBase.prototype.AddDisconnectedListener = function (method, context)
{
    this.OnDisconnected.Subscribe(method, context);
};

DirectVendorBase.prototype.RemoveDisconnectedListener = function (method, context)
{
    this.OnDisconnected.UnSubscribe(method, context);
};

DirectVendorBase.prototype.AddConnectionLostListener = function (method, context)
{
    this.OnConnectionLost.Subscribe(method, context);
};

DirectVendorBase.prototype.RemoveConnectionLostListener = function (method, context)
{
    this.OnConnectionLost.UnSubscribe(method, context);
};

DirectVendorBase.prototype.AddOnErrorListener = function (method, context)
{
    this.OnError.Subscribe(method, context);
};

DirectVendorBase.prototype.RemoveOnErrorListener = function (method, context)
{
    this.OnError.UnSubscribe(method, context);
};

DirectVendorBase.prototype.AddMessageListener = function (method, context)
{
    this.OnNewMessage.Subscribe(method, context);
};

DirectVendorBase.prototype.RemoveMessageListener = function (method, context)
{
    this.OnNewMessage.UnSubscribe(method, context);
};

DirectVendorBase.prototype.NotifyListeners = function (message)
{
    this.OnNewMessage.Raise(message);
};

DirectVendorBase.prototype.GenerateReportMessage = function (openOrderMessage)
{
    let reportMsgArr = generateReportMessageHandler.GenerateReportMessage(openOrderMessage);
    let len = reportMsgArr.length;
    for (let i = 0; i < len; i++)
        this.NotifyListeners(reportMsgArr[i]);
};

DirectVendorBase.prototype.Connect = function (params)
{
    var self = this;
    return self.ConnectProcessPromise(params)
        .then(function (connectionResult)
        {
            if (!connectionResult.Connected)
                return Promise.reject(connectionResult);

            return connectionResult;
        })
        .then(function (connectionResult)
        {
            self.Connected(connectionResult);
            return connectionResult;
        })
        .catch(function (dataError)
        {
            self.DisconnectProcessPromise();
            self.Disconnected(dataError);
            return dataError;
        });
};

DirectVendorBase.prototype.ConnectionLost = function ()
{
    this.OnConnectionLost.Raise();
}

DirectVendorBase.prototype.ErrorOccurred = function ()
{
    this.OnError.Raise();
}

// #region Trading

DirectVendorBase.prototype.placeOrder = function (data)
{

}

// TODO. Interface. Refactor.
DirectVendorBase.prototype.cancelOrder = function (order)
{

}

DirectVendorBase.prototype.closePositions = function (closePositionData)
{

}

DirectVendorBase.prototype.modifyPosition = function (data)
{

}

DirectVendorBase.prototype.modifyOrder = function (data)
{

}

// TODO. Refactor. Move to modifyOrder()?
DirectVendorBase.prototype.changeOrderToMarket = function (order)
{

}

// #endregion Trading

DirectVendorBase.prototype.Disconnect = function (disconectArguments)
{
    let self = this;

    this.DisconnectProcessPromise(disconectArguments ? disconectArguments.isNoNActivity : false)
        .catch(function (err) { console.error('Vendor disconnect error:' + err); })
        .then(function ()
        {
            clearInterval(self.crossRatesLoopHandler);
            self.Disconnected(disconectArguments);
        });
};

DirectVendorBase.prototype.ParseErrorMessage = function (text)
{
    try
    {
        let obj = JSON.parse(text);
        if (obj)
            return obj.message;
    }
    catch (ex)
    {
        ErrorInformationStorage.GetException(ex);
        return text;
    }
}

// TODO. Rename?
DirectVendorBase.prototype.Connected = function (connectedArguments)
{
    this.OnConnected.Raise(connectedArguments);
};

// TODO. Rename?
DirectVendorBase.prototype.Disconnected = function (disconectArguments)
{
    this.OnDisconnected.Raise(disconectArguments);
};

//#region Update Object Callbacks

DirectVendorBase.prototype.UpdateAccount = function (accMsg)
{
    this.NotifyListeners(accMsg);
};

DirectVendorBase.prototype.UpdatePosition = function (msg)
{
    this.NotifyListeners(msg);
};

DirectVendorBase.prototype.PositionClosedByServer = function (msg)
{
    this.NotifyListeners(msg);
};

DirectVendorBase.prototype.UpdateOrder = function (msg)
{
    this.NotifyListeners(msg);

    if (msg.OrderStatus !== null)
        this.GenerateReportMessage(msg);
};

// TODO. Doesn't feel right.
DirectVendorBase.prototype.OrderCancelledByServer = function (oom)
{
    let removeOrderMsg = new DirectRemoveOrderMessage();
    removeOrderMsg.OrderId = oom.OrderNumber;

    this.NotifyListeners(removeOrderMsg);

    if (oom.OrderStatus !== null)
        this.GenerateReportMessage(oom);
};

DirectVendorBase.prototype.NewQuote = function (msg)
{
    this.NotifyListeners(msg);
};

DirectVendorBase.prototype.AddAsset = function (currency)
{
    if (!currency)
        return;

    if (this.FAssets == null)
    {
        this.FAssets = new Object();
    }

    if (!this.FAssets.hasOwnProperty(currency))
    {
        this.FAssets[currency] = this.GetAssetMessage(Object.keys(this.FAssets).length, currency);
        this.NotifyListeners(this.FAssets[currency]);
    }
}
DirectVendorBase.prototype.GetAssetMessage = function (id, currency)
{
    var am = new DirectAssetMessage();
    am.Id = id;
    am.Name = am.Description = currency;
    am.MinChange = Math.pow(10, -2);
    return am;
}

DirectVendorBase.prototype.NewTrade = function (msg)
{
    this.NotifyListeners(msg);
}

//#endregion

//#region For Overriding

DirectVendorBase.prototype.ConnectProcessPromise = function (params) { };

DirectVendorBase.prototype.DisconnectProcessPromise = function () { };

DirectVendorBase.prototype.GetHistoryPromise = function (historyParams, loadFromServer, signal) { };

DirectVendorBase.prototype.GetRulesTable = function (account) { return new Object(); };

DirectVendorBase.prototype.SubscribeSymbol = function (vendorSymbol, quoteType) { }

DirectVendorBase.prototype.UnsubscribeSymbol = function (vendorSymbol, quoteType) { }

DirectVendorBase.prototype.GenerateReportPromise = function (reportId, paramDict) { };

DirectVendorBase.prototype.SendPing = function () { };

//#endregion For Overriding

//#region TODO. AuthData idk

DirectVendorBase.prototype.GetVendorName = function ()
{
    return this.vendorName;
};

DirectVendorBase.prototype.GetLogin = function () { return this.login; };

DirectVendorBase.prototype.getUserSessionId = function ()
{
    return this.userSessionId
}

//#endregion

DirectVendorBase.PFSVendor = 'PFIX'